import { Helmet } from "react-helmet-async";

const SEO = ({ 
  title, 
  description, 
  keywords,
  canonicalUrl,
  ogImage = "https://images.unsplash.com/photo-1706670351471-14d52ffa2e67?w=1200&q=80",
  ogType = "website"
}) => {
  const siteName = "Brunswick Glass";
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} | The Clear Choice for Quality Glass`;
  const defaultDescription = "Brunswick Glass serves coastal North Carolina with custom shower glass, window replacement, mirrors, and commercial glass solutions. Over 30 years of trusted craftsmanship.";
  
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="author" content="Brunswick Glass" />
      
      {/* Canonical URL */}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content={siteName} />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Geographic Tags */}
      <meta name="geo.region" content="US-NC" />
      <meta name="geo.placename" content="Brunswick County, North Carolina" />
      
      {/* Business Info */}
      <meta name="business:contact_data:street_address" content="Coastal North Carolina" />
      <meta name="business:contact_data:locality" content="Brunswick County" />
      <meta name="business:contact_data:region" content="NC" />
      <meta name="business:contact_data:country_name" content="United States" />
      <meta name="business:contact_data:phone_number" content="910-457-4757" />
    </Helmet>
  );
};

export default SEO;
